import ar from "./ar";
import en from "./en";

const translations = {
  ar: {
    translation: {
      ...ar,
    },
  },
  en: {
    translation: {
      ...en,
    },
  },
};

export default translations;